import styled from 'styled-components'
import { Eyebrow, Body12 } from 'components/Typography'
import {
  backgroundColor,
  display,
  maxWidth,
  space,
  textAlign,
  themeGet,
} from 'styled-system'
import { rem } from 'polished'

import { fadeInAnimation } from 'styles/animation'
import theme from 'styles/theme'
import { getBGColor, getMainFont } from 'utils/themeUtils'

export const CloseButton = styled.button`
  position: absolute;
  top: calc(${theme.space[3]} + ${theme.space[3]});
  left: ${theme.space[3]};
  margin: 0;
  padding: 0;
  background: none;
  border: 0;
  z-index: 1;

  > span,
  > span > svg {
    display: block;
  }

  ${theme.mediaQueries.medium} {
    left: ${theme.space[8]};
  }
`

export const Form = styled.form`
  position: relative;
  padding: ${theme.space[3]} ${theme.space[3]} ${theme.space[3]} 55px;
  background: ${(props) => props.theme.colors.sagelightToBG};

  ${theme.mediaQueries.medium} {
    padding: ${theme.space[3]};
  }
`

export const Input = styled.input`
  margin: 0;
  width: 100%;
  background: ${getBGColor()};
  border: 0;
  border-radius: 0;
  box-shadow: none;
  font-size: ${rem(12)};
  line-height: 2;
  text-transform: uppercase;
  outline: none;
  padding: 15px 50px 15px 20px;
  -webkit-appearance: none;

  ${theme.mediaQueries.medium} {
    margin: 0 0 ${theme.space[1]};
    background: none;
    color: ${themeGet('colors.sagedark')};
    font-size: ${rem(100)};
    font-family: ${getMainFont()};
    letter-spacing: ${rem('-0.6px')};
    text-align: ${(props) => (props.leftAlign ? 'left' : 'center')};
    text-transform: none;
    padding: 30px 75px;
  }
`

export const Label = styled.label`
  font-size: ${rem(12)};
  text-transform: uppercase;
  position: relative;

  span {
    display: ${(props) => (props.display ? 'block' : 'none')};
    position: absolute;
    left: 21px;
    top: 1px;
    overflow: hidden;
    white-space: nowrap;
    width: calc(100% - 70px);
  }

  ${theme.mediaQueries.medium} {
    font-size: ${rem(100)};
    font-family: ${getMainFont()};
    text-transform: none;

    span {
      color: ${themeGet('colors.sagedark')};
      left: 75px;
      top: 1px;
      width: calc(100% - 160px);
    }
  }
`

export const SearchButton = styled.button`
  position: absolute;
  top: 50%;
  right: calc(${theme.space[3]} + ${theme.space[4]});
  margin: 0;
  padding: 0;
  background: none;
  border: 0;
  transform: translateY(-50%);
  ${space}

  > span,
  > span > svg {
    display: block;
  }
`

export const SearchModal = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
  z-index: 100;
  opacity: ${(props) => (props.animation === 'out' ? 0 : 1)};
  animation: ${fadeInAnimation} 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
  ${backgroundColor}
  ${space}
`

export const Section = styled.div`
  ${display}
  ${maxWidth}
  ${space}
  ${textAlign}
  background: ${getBGColor()};
  
  * + & {
    margin-top: ${theme.space[5]};

    ${theme.mediaQueries.medium} {
      margin-top: ${theme.space[10]};
    }
  }

  ${(props) =>
    props.isBrandWrapper &&
    `
    > *:last-child {
      padding-bottom: ${theme.space[10]};
    }
  `}
`

export const ResultString = styled(Body12)`
  color: ${theme.colors.sage};
  text-transform: uppercase;
  letter-spacing: 1.5px;
  display: inline-block;
`

export const ResultLabel = styled(Eyebrow)`
  color: ${(props) => props.theme.colors.sagemediumToBlack};
  margin-left: 6px;
  text-transform: uppercase;
  display: inline-block;

  &::before {
    background: currentColor;
    content: '';
    display: inline-block;
    height: 3px;
    margin-right: 10px;
    transform: translateY(-2px) rotate(45deg);
    width: 3px;
  }

  html[dir='rtl'] & {
    margin-left: 0px;
    margin-right: 10px;

    &::before {
      margin-right: 0px;
      margin-left: 10px;
    }
  }
`
